import { NgModule } from '@angular/core';
import { AssetsRoutingModule } from './assets-routing.module';
import { NavigationPaneService, ToolbarService } from '@syncfusion/ej2-angular-filemanager';

@NgModule({
    imports: [
        AssetsRoutingModule,
    ],
    providers: [
        NavigationPaneService,
        ToolbarService,
    ],
})
export class AssetsModule {

}
